import { useEffect } from "react";
import { useMutation } from "convex/react";
import { startActivityTracker } from "@cheesy/contracts";
import { useLocation } from "react-router";
import { api } from "@/data/api";
import { useAppData } from "@/data/data-context";

export function ActivityTracker() {
  const { mode } = useAppData();
  const { pathname } = useLocation();
  return mode === "convex" && !pathname.endsWith("/launch") ? <ConnectedTracker /> : null;
}
function ConnectedTracker() {
  const send = useMutation(api.activity.heartbeat);
  useEffect(() => startActivityTracker(send), [send]);
  return null;
}
